'use client';
import dynamic from 'next/dynamic';

// Lazy facade. Same pattern as ProductBlockAsideModal/index.tsx.
//
// The modal is rendered hidden (open/close via useOpenRewardModal), so its
// JS chunk doesn't need to be in the initial bundle. ssr: true keeps the
// markup in the server HTML (SEO requirement: hidden modals must be in the
// initial response).
//
// formatRangeTitle and its type live in their own module (./formatRangeTitle)
// to keep the modal's chunk out of consumers that only need the formatter —
// webpack's static analysis would otherwise pull in the impl module whenever
// the facade is touched for any reason.
const RewardAsideModal = dynamic(() => import('./RewardAsideModalImpl'), {
  ssr: true,
});

export default RewardAsideModal;
export {
  formatRangeTitle,
  type FormatRangeTitleStaticText,
} from './formatRangeTitle';
